<template>
  <div v-cloak>

    <div>
      <!--<i class="el-icon-arrow-left"></i>-->
      <!--<span class="title">My To Do List</span>-->
    </div>

    <d1-vue-component ref="basicComponent" :options="generateOption" :dataFacetKey="dataFacetKey" :d1CoreBaseUrl="baseD1Url"
    ></d1-vue-component>
  </div>
</template>

<script>

  import d1VueComponent from '@/components/d1/d1-vue-component'


  export default {
    props: {
      bannerId: {
        type: String,
        required: true,
        default: () => {
        }
      }
    },
    components: {
      d1VueComponent
    },
    data(){
      return{
        generateOption: {
          queryUrl: '/dms/banner/list?id=' + this.bannerId ,
          importUrl: '',
          exportUrl: '/d1/export/async-export',
          deleteUrl: '',
          modifyUrl: '',
          pageSize: 10,
          tableData: [{}],
          pageSettingData: {
            form: [{}],
            table: [{}]
          },
          showToolbarButtonList: false,
          asyncExport:true,
          showExportButton:false,
          showSelectColumn: false,
          showTableSelection: false,
          showTableOperationButton: false,
          openform:true,
          showForm: false,
          showPagination: false,
          tableDataFormatter: false

        },
        dataFacetKey: 'ALL_BANNER_LATEST',
      }
    },
    computed: {

    },
    created(){
    },


    methods: {

    }
  }

</script>

<style lang="scss" scoped>
  [v-cloak] {
    display: none;
  }
  .breadcrumb{
    background-color: transparent !important;
    margin-bottom: 0px;
  }
  .title{
    margin-left: 16px;
    font-size: 20px;
  }

</style>



// WEBPACK FOOTER //
// src/view/store/banner_master/banner_information.vue